/* ============================================================================
   Pet's Table — TS002: el paso "Tus datos" deja de mentir
   ----------------------------------------------------------------------------
   COPIA de pt-order-datos.js con un cambio de fondo. El original no se toca:
   lo usa /pages/order.

   QUÉ PASABA (comprobado el 10-sep-2026 en la /pages/order VIVA, no deducido)

   El original marca los dos campos como "(Opcional)" y, cuando no valen,
   intenta pasar pulsando el botón oculto de saltar. Eso NO FUNCIONA:

     pt-plan-builder.js:121  v('lead') exige correo + teléfono de 10 dígitos
                             + casilla, en la variante A
     pt-plan-builder.js:187  go(n) revalida TODOS los pasos anteriores y
                             rebota al primero inválido
     pt-plan-builder.js:169  saltar hace go(PLANIDX) -> revalida el paso de
                             datos -> rebota a él mismo

   Resultado: con correo válido y "10100" en el WhatsApp (un CP, 5 dígitos) el
   precio se calcula —$837— y NUNCA se enseña. El usuario queda encerrado en un
   paso cuyas etiquetas le dicen que es opcional. José se topó con esto.

   QUÉ HACE ESTE ARCHIVO

   Decir la verdad. Los campos son OBLIGATORIOS en la variante A, así que se
   etiquetan como tales y, si algo falta, se explica qué falta en vez de dejar
   al usuario adivinando. La casilla se sigue ocultando y marcando, igual que
   el original, para que solo hagan falta dos cosas y no tres.

   LO QUE ESTE ARCHIVO NO PUEDE HACER

   Hacerlos opcionales de verdad. La única vía que el motor soporta es la
   variante B, y el motor decide AB él mismo (pb:39, con ?ab= o
   localStorage['pt_variant']): asignar window.PT_AB antes no hace nada, y
   sembrar el localStorage contaminaría también /pages/order en la misma
   pestaña. El arreglo de verdad son dos líneas en pt-plan-builder.js, que es
   compartido y lo regenera Jorge. Lo decide José.

   Mientras tanto, para revisar el diseño sin tropezar: abrir con ?ab=B.
   ========================================================================== */
(function () {
  'use strict';

  function variante() {
    try { return window.PT_AB || localStorage.getItem('pt_variant') || 'A'; }
    catch (e) { return window.PT_AB || 'A'; }
  }

  /* La B tiene su propio paso, con su propio "Saltar y ver mi precio" que sí
     funciona. Ahí no hay nada que arreglar. */
  if (variante() !== 'A') return;

  function montar() {
    var sec = document.getElementById('leadSec');
    if (!sec || sec.dataset.ptDatos) return false;

    var email = document.getElementById('leadEmail');
    var phone = document.getElementById('leadPhone');
    var btnNext = document.getElementById('leadNext');
    var consent = document.getElementById('leadConsent');
    if (!email || !phone || !btnNext) return false;

    sec.dataset.ptDatos = '1';

    /* ── Etiquetas honestas ──────────────────────────────────────────────
       El original ponía "(Opcional)" aquí. Era falso y es justo lo que hacía
       que la gente escribiera cualquier cosa —o nada— y quedara encerrada. */
    function marcar(campo, texto, ayuda) {
      var l = campo.previousElementSibling;
      if (l && l.classList.contains('fl')) {
        l.innerHTML = texto + ' <span class="pt-ts002-req">' + ayuda + '</span>';
      }
    }
    marcar(email, 'Correo', '· para enviarte tu plan');
    marcar(phone, 'WhatsApp', '· 10 dígitos');

    /* La casilla se oculta y se deja marcada, como el original: así solo hacen
       falta dos cosas y no tres. La condición del motor la sigue leyendo. */
    var etiqueta = sec.querySelector('.leadconsent');
    if (etiqueta) etiqueta.style.display = 'none';
    if (consent) consent.checked = true;

    /* ── Decir QUÉ falta ─────────────────────────────────────────────────
       El motor, cuando no valida, hace flash() con un texto genérico. Aquí se
       señala el campo concreto, que es la diferencia entre corregirlo en dos
       segundos y abandonar. Va en captura y NO detiene la propagación: el
       motor sigue haciendo su parte. */
    var aviso = document.createElement('div');
    aviso.className = 'pt-ts002-aviso';
    aviso.setAttribute('role', 'alert');
    aviso.hidden = true;
    btnNext.parentNode.insertBefore(aviso, btnNext);

    function revisar() {
      var correoOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value || '');
      var digitos = String(phone.value || '').replace(/\D/g, '');
      var telOk = digitos.length >= 10;
      var faltan = [];
      if (!correoOk) faltan.push(email.value ? 'el correo no parece válido' : 'falta tu correo');
      if (!telOk) {
        faltan.push(!digitos.length ? 'falta tu WhatsApp'
          : 'el WhatsApp necesita 10 dígitos (llevas ' + digitos.length + ')');
      }
      email.classList.toggle('pt-ts002-mal', !correoOk && !!email.value);
      phone.classList.toggle('pt-ts002-mal', !telOk && !!digitos.length);
      return faltan;
    }

    btnNext.addEventListener('click', function () {
      var faltan = revisar();
      aviso.hidden = !faltan.length;
      if (faltan.length) aviso.textContent = 'Para ver tu precio: ' + faltan.join(' y ') + '.';
    }, true);

    /* Al escribir, el aviso se corrige solo: nadie tiene que volver a pulsar
       para saber si ya va bien. */
    [email, phone].forEach(function (c) {
      c.addEventListener('input', function () {
        if (aviso.hidden) return;
        var faltan = revisar();
        aviso.hidden = !faltan.length;
        if (faltan.length) aviso.textContent = 'Para ver tu precio: ' + faltan.join(' y ') + '.';
      });
    });

    return true;
  }

  if (!montar()) {
    var n = 0;
    var t = setInterval(function () { if (montar() || ++n > 60) clearInterval(t); }, 250);
  }
})();
